const stationServiceRouter = {
  path: "/stationService", //主体
  name: "stationService",
  redirect: "/orgBuild",
  component: () => import("../views/stationService/main"),
  children: [
    {
      path: "/orgBuild",
      name: "orgBuild",
      mate: {
        title: ""
      },
      component: () => import("../views/stationService/orgBuild/index"),
      redirect: "/communityManageZD",
      children: [
        {
          path: "/communityManageZD",
          name: "communityManageZD",
          mate: {
            title: "社区站点"
          },
          component: () =>
            import("../views/stationService/orgBuild/communityManage/index")
        },
        {
          path: "/orgWork",
          name: "orgWork",
          mate: {
            title: "组织工作"
          },
          component: () =>
            import("../views/stationService/orgBuild/orgWork/index")
        },

        // 新增数据字典模块
        {
          path: "/dictionary",
          name: "dictionary",
          mate: {
            title: "数据字典"
          },
          component: () =>
            import("../views/stationService/orgBuild/dictionary/index"),
          redirect: "/certificateNameZD",
          children: [
            {
              path: "/certificateNameZD",
              name: "certificateNameZD",
              mate: {
                title: "证书名称"
              },
              component: () =>
                import("../views/stationService/orgBuild/dictionary/certificateNameZD")
            },

            {
              path: "/certificateTypeZD",
              name: "certificateTypeZD",
              mate: {
                title: "证书类型"
              },
              component: () =>
                import("../views/stationService/orgBuild/dictionary/certificateTypeZD")
            }
          ]
        }
      ]
    }
  ]
}

export default stationServiceRouter
